import {Button} from '@hm/fundamental'
import {mdiClose} from '@mdi/js'

interface DeleteDocumentButtonProps {
  isDisabled?: boolean
  onDocumentDelete: () => void
}

export const DeleteDocumentButton: React.FC<DeleteDocumentButtonProps> = ({
  isDisabled = false,
  onDocumentDelete
}) => {
  return (
    <Button
      round
      square
      icon={mdiClose}
      size="extraSmall"
      disabled={isDisabled}
      onClick={(e) => {
        e.preventDefault()
        onDocumentDelete()
      }}
      className="absolute right-0 top-0 translate-x-1/2 -translate-y-1/2 z-[5]"
      data-cy="attached_document_delete_button"
    />
  )
}
